//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        data: {
            type: Array
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            swiperOption: {
                direction: 'vertical',
                slidesPerView: 'auto',
                freeMode: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true
                },
                mousewheel: true,
                observer: true,
                observeParents: true
            }
        }
    },
    computed: {},
    created() {
        var _this = this
        this.$nextTick(function() {
            console.log(this.$refs.main)
            var scrollmain = this.$refs.main
            scrollmain.addEventListener('scroll', function() {
                var scrollTop = this.scrollTop
                _this.$refs.thead.style.transform = 'translateY(' + scrollTop + 'px)'
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/tablelist.vue